






















































import {ComponentBase, Overlay} from "@/modules/budget/staffing-table/components";
import {Component, Prop} from "vue-property-decorator";
import {BudgetVariants, Comp, Dict} from "@/modules/budget/staffing-table/types";
import {staffTabAccess} from "@/modules/budget/staffing-table/common";
import i18n from "@/services/i18n";

const translates = {
    tools: {
        buttons: {
            get downloadTarificationReport(): string {
                return i18n.choose(
                    'Тарификационный список',
                    'Тарификациялық тізім',
                    'Tarification Report',
                );
            },
            get downloadStaffTabReport(): string {
                return i18n.choose(
                    'Штатное расписание',
                    'Штаттық кесте',
                    'Staffing table report',
                );
            },
        },
        field: {
            get periodTitle(): string {
                return i18n.choose(
                    'Дата отчёта',
                    'Дата отчёта (каз)',
                    'Take period',
                );
            },
            get chooseTitle(): string {
                return i18n.choose(
                    'Выбрать',
                    'Выбрать (каз)',
                    'Choose',
                );
            }
        },
        months: {
            get january(): string {
                return i18n.choose(
                    'Января',
                    'Қаңтар',
                    'January',
                );
            },
            get september(): string {
                return i18n.choose(
                    'Сентября',
                    'Кыркүйек',
                    'September',
                );

            }
        }
    }
};

interface ReportSettings {
    reportDate: number | null;
    budgetVariantUUID: string ;
    abpCode: number;
    staffTabVersionId: number;
    budgetProgramCode: number | null;
    detailedReport: boolean
    debug: boolean
}

@Component({
    components: {
        Overlay
    }
})

export default class GenerateStaffTabReport extends ComponentBase {
    constructor() {
        super('modules.budget.staffing_table.reports.*XlsxGenerationPane*');
    }

    @Prop({ type: String, default: null })
    public readonly regionCode!: string | null;

    @Prop({ type: Number, default: null })
    public readonly abpCode!: number | null;

    @Prop({ type: Object, default: null })
    public readonly budgetVariant!: BudgetVariants  | null;

    @Prop({ type: Number, default: null })
    public readonly staffTabVersionId!: number | null;

    @Prop({ type: Number, required: true })
    public readonly reportYear!: number;

    @Prop({ type: Object, default: null })
    public readonly budgetProgram!: Dict.EbkFunc | null;
    // endregion

    protected created() {
        super.created();
        this.$watch('reportYear', () => {
           this.selectedPeriod = null
        });
        this.$watch('abpCode', (abpCode: number | null) => {
            if (abpCode !== 261 && abpCode !== 360) {
                this.selectedPeriod = null
            }
        });
    }

    protected mounted() {
        super.mounted();
    }

    // region Утилиты
    public translates = translates;

    // Ключ индивидуального сводного отчета
    private SVD_IND = "SVD_IND"

    /** АБП - образование */
    readonly  education = [261, 360];

    // region Расширенный отчет, отладка
    public detailedReport = false;

    public debugging = false;

    // Доступ к редактированию данных
    get isEditable(): boolean {
        return staffTabAccess.isEditable;
    }

    private selectedPeriod: Comp.DropdownItemDef<Date> | null = null;
    private get optionByPeriod(): Array<Comp.DropdownItemDef<Date>> {
        const periodLst: { text: string; value: Date }[] = [];
        const year = this.reportYear
            periodLst.push({text: `01 ${translates.tools.months.january} ${year}`, value: new Date(Date.UTC(year, 0, 1))});
            periodLst.push({text: `01 ${translates.tools.months.september} ${year}`, value: new Date(Date.UTC(year, 8, 1))});
        return periodLst;
    }

    private get abpIsEducation(): boolean {
        return (this.abpCode !== null && this.education.includes(this.abpCode));
    }

    private get getAbp(): number | null {
        return this.abpCode ?? null;
    }

    get versionIsNotNull(): boolean {
        return (this.staffTabVersionId != null);
    }
    // endregion

    private areRequiredSettingFilled(
        action: (settings: ReportSettings) => void
    ) {
        const variantUuid = this.budgetVariant?.variantUuid ?? null
        if (variantUuid == null) {
            this.toast('info', 'Ошибка фильтра', `Выберите версию бюджета`);
            console.error('Cannot define budget variant UUID');
            return;
        }

        const staffTabVersionId = this.staffTabVersionId ?? null
        if (staffTabVersionId == null) {
            this.toast('info', 'Ошибка фильтра', `Выберите версию штатного расписания`);
            console.error('Version ID is null');
            return;
        }
        const abpCode = this.getAbp
        if (abpCode == null) {
            this.toast('info', 'Ошибка фильтра', `Укажите - АБП`);
            console.error('ABP is null');
            return;
        }

        const budgetProgramCode = this.budgetProgram?.prg ?? null;

        const detailedReport = this.detailedReport;
        const reportDate = this.selectedPeriod?.value.getTime() ?? null;
        const debugging = this.debugging;

        const settings: ReportSettings = {
            reportDate: reportDate,
            budgetVariantUUID: variantUuid,
            abpCode: abpCode,
            staffTabVersionId: staffTabVersionId,
            budgetProgramCode: budgetProgramCode,
            detailedReport: detailedReport,
            debug: debugging
        };

        // Вызываем переданную функцию с параметрами settings
        action(settings);
    }

    generateStaffingTableReport(generatorType: string, isEdu: boolean) {
        this.areRequiredSettingFilled((settings) => {
                const locale = i18n.locale

                const url = this.prepareUrl(
                    '/api/budget/staffing_table/staffing-table-report/generate',
                    [
                        ['report-date',   settings.reportDate],
                        ['staff-tab-versionId',   settings.staffTabVersionId],
                        ['variant-uuid',      settings.budgetVariantUUID],
                        ['abp-code',      settings.abpCode],
                        ['budget-program-code', settings.budgetProgramCode],
                        ['generator-type', generatorType],
                        ['education', isEdu],
                        ['detailedReport', settings.detailedReport],
                        ['debug', settings.debug],
                        ['locale', locale],
                    ],
                );
                window.open(url, '_blank');
            }
        )
    }

}
